import { render, staticRenderFns } from "./GameOfLife.vue?vue&type=template&id=248cb2f6&scoped=true&"
import script from "./GameOfLife.component.js?vue&type=script&lang=js&"
export * from "./GameOfLife.component.js?vue&type=script&lang=js&"
import style0 from "./GameOfLife.vue?vue&type=style&index=0&id=248cb2f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cb2f6",
  null
  
)

export default component.exports